import { BaseComponent } from "../../BaseComponent.js";
import { state } from "lit/decorators.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { prop } from "../../../decorators/prop/index.js";
import { html } from "lit";
import { sizes } from "../SelectBase/index.js";
import { preventDefault } from "../../../decorators/preventDefault.js";
import "../SearchInput/index.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let DsfAutocomplete = class extends BaseComponent {
  constructor() {
    super(...arguments);
    this.dsf_searching = false;
    this.disabled = false;
    this.dsf_search_error = false;
    this.dsf_search_success = false;
    this.dsf_size = "medium";
    this._searchValue = "";
    this._focused = false;
  }
  handleChange(ev) {
    this.updateSearchValue("");
    this.value = ev.detail.length ? ev.detail[0] : void 0;
    this.emit({ name: "change", payload: this.value });
  }
  onIconClick() {
    this.updateSearchValue("");
    this.value = void 0;
    this.emit({ name: "change", payload: this.value });
  }
  onBackspace(e) {
    if (this.value && e.key === "Backspace") {
      this.updateSearchValue("");
      this.value = void 0;
      this.emit({ name: "change", payload: this.value });
    }
  }
  handleSearchInput(event) {
    this.updateSearchValue(event.detail);
  }
  updateSearchValue(value) {
    this._searchValue = value;
  }
  handleBlur() {
    if (this._searchValue && !this.value) {
      this.updateSearchValue("");
      this.value = void 0;
    }
    this._focused = false;
  }
  handleFocus() {
    this._focused = true;
    this.updateSearchValue(this.dsf_display_value || this.value || "");
  }
  get inputValue() {
    if (this._focused) {
      return this._searchValue;
    } else {
      return this.dsf_display_value || this.value || "";
    }
  }
  render() {
    return html`
      <dsf-select-base
        .value=${this.value ? [this.value] : []}
        exportparts="dropdown,list"
        dsf_same_width
        dsf_disable_search
        .dsf_size=${this.dsf_size}
        .disabled=${this.disabled}
        .dsf_search_type=${this.dsf_search_type}
        .dsf_no_results_text=${this.dsf_no_results_text}
        .dsf_title_text=${this.dsf_title_text}
        .dsf_message=${this.dsf_search_message}
        .dsf_error=${this.dsf_search_error}
        .dsf_success=${this.dsf_search_success}
        @change=${this.handleChange}
        @icon-right-click=${this.onIconClick}
      >
        <dsf-search-input
          .value=${this.inputValue}
          class="w-full"
          .dsf_size=${this.dsf_size}
          .dsf_loading=${this.dsf_searching}
          .dsf_placeholder=${this.dsf_placeholder}
          .dsf_label=${this.dsf_label}
          .dsf_error=${this.dsf_search_error}
          .dsf_success=${this.dsf_search_success}
          .disabled=${this.disabled}
          slot="button"
          @keydown=${this.onBackspace}
          @input=${this.handleSearchInput}
          @blur=${this.handleBlur}
          @focus=${this.handleFocus}
        >
        </dsf-search-input>
        <slot></slot>
      </dsf-select-base>
    `;
  }
};
__decorateClass([
  prop({ type: String, reflect: true })
], DsfAutocomplete.prototype, "value", 2);
__decorateClass([
  prop({ type: String })
], DsfAutocomplete.prototype, "dsf_display_value", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfAutocomplete.prototype, "dsf_searching", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfAutocomplete.prototype, "disabled", 2);
__decorateClass([
  prop({ type: String, reflect: true })
], DsfAutocomplete.prototype, "dsf_search_type", 2);
__decorateClass([
  prop({ type: String })
], DsfAutocomplete.prototype, "dsf_no_results_text", 2);
__decorateClass([
  prop({ type: String })
], DsfAutocomplete.prototype, "dsf_title_text", 2);
__decorateClass([
  prop({ type: String })
], DsfAutocomplete.prototype, "dsf_placeholder", 2);
__decorateClass([
  prop({ type: String })
], DsfAutocomplete.prototype, "dsf_search_message", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfAutocomplete.prototype, "dsf_search_error", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfAutocomplete.prototype, "dsf_search_success", 2);
__decorateClass([
  prop({ type: String })
], DsfAutocomplete.prototype, "dsf_label", 2);
__decorateClass([
  prop({ type: String, reflect: true, validator: (value) => sizes.includes(value) })
], DsfAutocomplete.prototype, "dsf_size", 2);
__decorateClass([
  state()
], DsfAutocomplete.prototype, "_searchValue", 2);
__decorateClass([
  state()
], DsfAutocomplete.prototype, "_focused", 2);
__decorateClass([
  preventDefault
], DsfAutocomplete.prototype, "handleChange", 1);
DsfAutocomplete = __decorateClass([
  defineElement("dsf-autocomplete")
], DsfAutocomplete);
export {
  DsfAutocomplete
};
